var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgRealizedIncome = function SvgRealizedIncome(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.21,
    height: 20.375,
    viewBox: "0 0 22.21 20.375",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69871",
    "data-name": "Group 69871",
    transform: "translate(0 -44.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3910_",
    transform: "translate(0 44.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3553_",
    transform: "translate(3.367 3.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3785_",
    transform: "translate(0.057 5.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3791_",
    transform: "translate(10.102 1.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34249",
    "data-name": "Path 34249",
    d: "M242.484,238.6a.84.84,0,0,1-.84-.84v-5.094a.84.84,0,1,1,1.679,0v5.094A.84.84,0,0,1,242.484,238.6Z",
    transform: "translate(-241.644 -231.823)",
    fill: "#8d8db5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3790_",
    transform: "translate(6.735 4.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34250",
    "data-name": "Path 34250",
    d: "M182.325,284.507a.84.84,0,0,1-.84-.84v-2.372a.84.84,0,1,1,1.679,0v2.372A.84.84,0,0,1,182.325,284.507Z",
    transform: "translate(-181.485 -280.455)",
    fill: "#ffd45d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3789_",
    transform: "translate(13.48 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34251",
    "data-name": "Path 34251",
    d: "M302.822,264.83a.84.84,0,0,1-.84-.84v-3.539a.84.84,0,1,1,1.679,0v3.539A.84.84,0,0,1,302.822,264.83Z",
    transform: "translate(-301.982 -259.612)",
    fill: "#8d8db5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3787_",
    transform: "translate(3.367 2.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34253",
    "data-name": "Path 34253",
    d: "M122.166,251.714a.84.84,0,0,1-.84-.84v-4.317a.84.84,0,1,1,1.679,0v4.317A.84.84,0,0,1,122.166,251.714Z",
    transform: "translate(-121.326 -245.718)",
    fill: "#8d8db5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3786_",
    transform: "translate(0 5.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34254",
    "data-name": "Path 34254",
    d: "M62.007,297.624a.84.84,0,0,1-.84-.84V295.19a.84.84,0,1,1,1.679,0v1.594A.84.84,0,0,1,62.007,297.624Z",
    transform: "translate(-61.167 -294.35)",
    fill: "#8d8db5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34255",
    "data-name": "Path 34255",
    d: "M75.332,102.267l-.489-1.591a.69.69,0,0,0-.888-.443l-1.511.556a.689.689,0,0,0-.407.883.682.682,0,0,0,.843.421l-1.229,2.675-1.609-2.163a1.2,1.2,0,0,0-1.976.109l-1.826,3.116-1.711-1.871a1.2,1.2,0,0,0-1.818.082l-2.425,3.18a.7.7,0,0,0,.071.918.687.687,0,0,0,1.014-.08l2.3-3.011,1.73,1.892a1.2,1.2,0,0,0,1.9-.2l1.812-3.092,1.627,2.188a1.2,1.2,0,0,0,2.032-.215l1.3-2.836a.688.688,0,0,0,.9.314A.7.7,0,0,0,75.332,102.267Z",
    transform: "translate(-60.145 -100.193)",
    fill: "#ffd45d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_",
    transform: "translate(0.062 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34256",
    "data-name": "Path 34256",
    d: "M22.513,64.876H1.835a.793.793,0,0,1-.735-.84V53.877a.793.793,0,0,1,.735-.84.793.793,0,0,1,.735.84V63.2H21.778V46.179H2.57v1.466a.793.793,0,0,1-.735.84.793.793,0,0,1-.735-.84V45.34a.793.793,0,0,1,.735-.84H22.513a.793.793,0,0,1,.735.84v18.7A.793.793,0,0,1,22.513,64.876Z",
    transform: "translate(-1.1 -44.5)",
    fill: "#8d8db5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_",
    transform: "translate(0 5.366)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5823",
    "data-name": "Ellipse 5823",
    cx: 0.901,
    cy: 0.905,
    rx: 0.901,
    ry: 0.905,
    fill: "#8d8db5"
  }))))));
};

export default SvgRealizedIncome;